<!--
    描述：六算分析图 首页
    时间：2020-05-25
    Create by zwh
-->
<template>
	<div class="estimate-price-layout">
		<div class="estimate-price-left"
			 :style="activeStyle">
			<chartProjectStructure ref="chartProjectStructure"
								   :projectId="curProjectId"
								   @changeShow="changeLeftShow"
								   @row-click="leftRowClick"></chartProjectStructure>
		</div>

		<!-- 右侧表格 -->
		<div class="estimate-price-right">
			<div class="baseList-layout">
				<div class="baseList-header">
					<div class="left-text overflow-hidden header-title">
						<!--						<el-tooltip class="item"
                                                            effect="dark"
                                                            :content="rowNodeName"
                                                            placement="bottom-start">
                                                    <span>{{ rowNodeShowName }}</span>
                                                </el-tooltip>-->
					</div>
					<div class="btnGroups">
						<el-button-group>
							<el-button v-show="chartType == 'bar'"
									   icon="el-icon-upload"
									   type="primary"
									   size="small"
									   v-if="roleBtns.includes('chart-export')"
									   @click="exportChart">导出</el-button>
							<el-button class="ml5"
									   size="small"
									   :class="{'btnIsActive' : chartType == 'bar'}"
									   @click="chartBtnClick('bar')">柱状图 / 折线图</el-button>
							<el-button size="small"
									   :class="{'btnIsActive': chartType == 'pie'}"
									   @click="chartBtnClick('pie')">饼图</el-button>
						</el-button-group>
					</div>
				</div>

				<!-- 表格主体 -->
				<div class="baseList-content">
					<chartAnalysisEChart ref="chartAnalysisEChart"
										 @left-resize="leftResize"></chartAnalysisEChart>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import chartProjectStructure from './components/chart_project_structure'
	import { mapState } from 'vuex'
	import chartAnalysisEChart from './components/chart_analysis_eChart'
	export default {
		name: '',
		components: { chartProjectStructure, chartAnalysisEChart },
		data() {
			return {
				leftShow: true, // 左侧是否展示
				chartType: 'pie',

				rowNodeShowName: '',
				rowNodeId: '',
				rowNodeName: ''
			}
		},
		mounted() {},
		created() {},
		computed: {
			// 当前的 项目来源：'0' 是造价系统的， '1' 是审计系统推送的
			curSource() {
				return this.$route.query.source || '0'
			},
			// 当前的 项目Id
			curProjectId() {
				return this.$route.query.projectId
			},
			...mapState('menu', {
				roleBtns: state => state.roleBtns
			}),
			// 动态左侧样式
			activeStyle() {
				if (!this.leftShow) {
					return {
						width: '50px'
					}
				}
				return { width: '440px' }
			}
		},
		methods: {
			chartBtnClick(chartType) {
				if (this.chartType == chartType) return
				this.chartType = chartType
				if (this.rowNodeId) {
					setTimeout(() => {
						this.$refs.chartAnalysisEChart.initCharts(
								chartType,
								this.rowNodeId
						)
					}, 300)
				}
			},
			// 导出图片
			exportChart() {
				this.$refs.chartAnalysisEChart.exportChart(
						this.rowNodeShowName,
						this.rowNodeName
				)
			},

			//项目结构点击
			leftRowClick(structureData, row) {
				let that = this
				let _pname = structureData[0].sname
				let name = row.sname

				this.rowNodeId = row.id
				this.rowNodeName = name

				// 设置右边结构名字
				if (row.levelType === 0) {
					this.rowNodeShowName = name
				} else if (row.levelType === 1) {
					this.rowNodeShowName = _pname + ' | ' + name
				} else {
					// 当前结构树ID
					let _dname = structureData[0].children.find(
							x => x.id === row.pid
					).sname
					this.rowNodeShowName = _pname + ' | ' + _dname + ' | ' + name
				}

				// 右侧图表
				if (row && row.id) {
					this.$refs.chartAnalysisEChart.rowClickInitEChart(
							row,
							this.chartType,
							this.rowNodeShowName,
							this.rowNodeName
					)
				}
			},
			// 左侧点击展示/隐藏
			changeLeftShow(status) {
				this.leftShow = status

				//右侧图表自适应
				this.$refs.chartAnalysisEChart.leftShowResize()
			},
			//项目结构高度自适应
			leftResize() {
				this.$refs.chartProjectStructure.resizeTableH()
			}
		}
	}
</script>
<style lang="less" scoped>
	.estimate-price-layout {
		height: 100%;
		display: flex;
		background-color: #fff;

		.estimate-price-left {
			width: 440px;
			height: 100%;
			padding: 0 10px;
			overflow: auto;
			border-right: 1px solid #ccc;

			.baseForm-header {
				color: #07a2ea;
				overflow: hidden;
			}
		}

		.estimate-price-right {
			flex: 1;
			overflow: auto;
			padding: 0 10px;
			.baseList-layout {
				position: relative;
				padding-top: 42px;
				height: 100%;
				.baseList-header {
					padding: 0 10px;
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 42px;
					line-height: 42px;
					background-color: #fff;
					display: flex;
					justify-content: flex-end;
					border-bottom: 1px solid #ccc;

					.left-text {
						position: absolute;
						left: 0px;
						display: flex;
						align-items: center;
						padding-left: 10px;
						color: #0c1c21;
						font-size: 16px;
						font-weight: bold;
					}

					.btnGroups {
						float: right;
						display: flex;
						align-items: center;
						height: 100%;
						box-sizing: border-box;

						.btnIsActive {
							background-color: #c5eafc;
						}
					}
				}

				.baseList-content {
					padding: 0 0 5px;
					overflow-y: hidden;
					height: 100%;
				}
			}
		}
	}
</style>